import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { getLogger } from '../utils/logger';

// Create a namespaced logger
const logger = getLogger('Auth');

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check current auth status
    const checkAuth = async () => {
      logger.log('Checking initial auth status...');
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          logger.error('Error checking auth status:', error);
        }
        
        const hasSession = !!session;
        logger.log('Initial session exists:', hasSession);
        setIsAuthenticated(hasSession);
        setUser(session?.user || null);
        
        if (session?.user) {
          logger.log('User ID:', session.user.id);
          logger.log('User email:', session.user.email);
        }
      } catch (error) {
        logger.error('Exception in checkAuth:', error);
      } finally {
        logger.log('Initial auth check complete, setting isLoading to false');
        setIsLoading(false);
      }
    };

    checkAuth();

    // Subscribe to auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      logger.log('Auth state changed. Event:', event);
      logger.log('New session exists:', !!session);
      
      const hasSession = !!session;
      setIsAuthenticated(hasSession);
      setUser(session?.user || null);
      
      if (session?.user) {
        logger.log('User ID:', session.user.id);
        logger.log('User email:', session.user.email);
      }
      
      logger.log('Setting isLoading to false after auth state change');
      setIsLoading(false);
    });

    return () => {
      logger.log('Cleaning up auth subscription');
      subscription.unsubscribe();
    };
  }, []);

  logger.log('Current state:', { isAuthenticated, isLoading, hasUser: !!user });
  return {
    isAuthenticated,
    isLoading,
    user
  };
};